import {FilterGroup} from '@/domain/services/Clas';

export const getUrlWithParamsFromObject = (baseUrl: string, filterGroup: FilterGroup, hasYear: boolean) => {

  const operator = hasYear ? '&' : '?';

  // elimina claves con valor undefined o vacíos
  const cleanFilterGroup = Object.fromEntries(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    Object.entries(filterGroup).filter(([_, value]) => value !== undefined && value !== '')
  );

  const queryParams = Object.entries(cleanFilterGroup)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join('&');

  return queryParams ? `${baseUrl}${operator}${queryParams}` : baseUrl;
  
};